import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useState, useRef } from "react";
import apple from "../../../../../assets/fruits/apple-tree.jpg";
import avocado from "../../../../../assets/fruits/avocado-tree.webp";
import almond from "../../../../../assets/fruits/almond-tree.webp";
import fig from "../../../../../assets/fruits/fig tree.webp";
import guava from "../../../../../assets/fruits/guava tree.webp";
import juglans from "../../../../../assets/fruits/juglans tree.jpg";
import kumquat from "../../../../../assets/fruits/kumquat-tree.jpg";
import lychee from "../../../../../assets/fruits/lychee-tree.webp";
import limequat from "../../../../../assets/fruits/limequat.jpg";
import lime from "../../../../../assets/fruits/lime-trees-fruit.jpg";
import lemon from "../../../../../assets/fruits/lemon-tree.jpg";
import orange from "../../../../../assets/fruits/orange tree.jpg";
import olive from "../../../../../assets/fruits/oliv-tree.jpg";
import plum from "../../../../../assets/fruits/plum-tree.webp";
import peach from "../../../../../assets/fruits/peach-tree.jpg";
import passion from "../../../../../assets/fruits/passion-tree.jpg";
import pomegranat from "../../../../../assets/fruits/pomeg treee.webp";
import pinus from "../../../../../assets/fruits/pinus-pea-tree.jpg";
import mango from "../../../../../assets/fruits/mango tree.jpg";
import './Fruits.css'
import BackIcon from "../../../../../components/back/back";
const FruitsFamilies = [
    { id: 1, name: "Apples", img: apple },
    { id: 2, name: "Avocado", img: avocado },
    { id: 3, name: "Almond", img: almond },
    { id: 4, name: "Fig", img: fig },
    { id: 5, name: "Guava", img: guava },
    { id: 6, name: "Juglans", img: juglans },
    { id: 7, name: "Kumquat", img: kumquat },
    { id: 8, name: "Lychee", img: lychee },
    { id: 9, name: "Limequat", img: limequat },
    { id: 10, name: "Lime", img: lime },
    { id: 11, name: "Lemon", img: lemon },
    { id: 12, name: "Orange", img: orange },
    { id: 13, name: "Olive", img: olive },
    { id: 14, name: "Plum", img: plum },
    { id: 15, name: "Peach", img: peach },
    { id: 16, name: "Passion Fruit", img: passion },
    { id: 17, name: "Pomegranate", img: pomegranat },
    { id: 18, name: "Pinus", img: pinus },
    { id: 19, name: "Mango", img: mango },
];

export default function FruitsCategoriesDesktop() {

    return (
        <div className="fruits-container">
            <BackIcon />
        <div className="title-overlay">
            <h1>fruits Collection</h1>
        </div>
        <div className="plants-category-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8" style={{ marginTop: "5rem" }}>
            {FruitsFamilies.map((fruits) => (
                <div key={fruits.id} className=" fruits-shape-card bg-white p-6 rounded-xl shadow-lg transform transition-all hover:scale-105">
                    <img
                        src={fruits.img}
                        alt={fruits.name}
                        className="w-full h-60 object-cover rounded-lg mb-4"
                    />
                    <p className="plant-name">{fruits.name}</p>
                </div>
            ))}
        </div>
    </div>
    );
}
